import type { Reducer } from 'redux';
import type { LearnosityData } from 'type-props/learnosity-types';

import { ACTIONS } from 'actions/learnosity-config';

type InitialState = {
  learnosity?: LearnosityData | null;
  responseIdReferenceMap: Record<string, string>;
};

type PolypadToolsReducer = Reducer<InitialState>;

const initialState: InitialState = {
  learnosity: null,
  responseIdReferenceMap: {},
};

const reducer: PolypadToolsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  if (type === ACTIONS.SET_LEAROSITY_OBJECT) {
    return {
      ...state,
      learnosity: payload.learnosityObject,
    };
  }

  if (type === ACTIONS.SET_RESPONSE_ID_REFERENCE_MAP) {
    return {
      ...state,
      responseIdReferenceMap: payload.responseIdReferenceMap,
    };
  }

  if (type === ACTIONS.CLEAR_LEARNOSITY_CONFIG) {
    return initialState;
  }

  return state;
};

export default reducer;
